module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuOBs0TtgAAACTSURBVDhPtZTRDYAgDAXZhyUcgVVcy7UYpLaASSsPQrA2uY9eeARSNBCRK1B+AUoNV2SORkRrNFAKXInJjDQacQllBCxDOFt4xgWznagn08EZ3UlNUwS+5ojc5U1TB6ADK5hBvTeUSerFKxxmD9P8sKHvlYvwHEoR3s+mSH60KjRi7WE/cPl9ehoun5/DLlDuQ+EGLUj4kqGzHA4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/procedure_black.png
// module id = 3MKR
// module chunks = 1